import React from 'react';
import Button from "components/button";
import {
    Bot,
    CheckCheck,
    Loader2,
} from "lucide-react";

function AIButton({state, calllHandler, extra, ...props}) {
  
    return (
      <Button
        type="button"
        className={`aibutton
          focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] a
          ria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive 
          hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50 ${extra}`}
        onClick={calllHandler}
      >
        {state.aiLoading ? (
            <>
                <Loader2 className="size-4 animate-spin"/>
                <span>Loading...</span>
            </>
        ) : state.aiAsked ? (
            <>
                <CheckCheck className="size-4"/>
                <span>Ask again</span>
            </>
        ) : (
            <>
                <Bot className="size-4"/>
                <span>Ask AI</span>
            </>
        )}
    </Button>
    );
}

export default AIButton;
